<template>
<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
      d="M11.9949 0.595625C11.9949 0.336845 11.7851 0.127075 11.5263 0.127075H0.47368C0.215017 0.127075 0.00527118 0.336681 0.00513062 0.595344L0 9.40436C0 9.66314 0.20977 9.87291 0.46855 9.87291L11.5315 9.87293C11.7903 9.87293 12.0001 9.66299 12 9.4041L11.9949 0.595625ZM0.937099 2.04513L3.04993 4.97181L0.937099 7.79976V2.04513ZM8.07918 4.50801H3.8709L1.3847 1.06417H10.6022L8.07918 4.50801ZM3.86607 5.44511H8.0777L10.608 8.93581H1.25808L3.86607 5.44511ZM8.89651 4.97804L11.0578 2.028V7.95961L8.89651 4.97804Z"
      fill="#B5C6D8"/>
</svg>
</template>
